import { ArrowRight, BarChart3, Users } from "lucide-react";
import StarRating from "./StarRating";

interface Props {
  nomor: number;
  pertanyaan: string;
  rataRata: number;
  totalResponden: number;
}

const SummaryCard = ({ nomor, pertanyaan, rataRata, totalResponden }: Props) => {
  const progress = (rataRata / 5) * 100;

  return (
    <div
      className="
        group
        relative
        overflow-hidden
        rounded-3xl
        border
        border-lime-100
        bg-white
        p-6
        shadow-[0_10px_35px_rgba(132,204,22,0.08)]
        transition-all
        duration-500
        hover:-translate-y-1
        hover:border-lime-300
        hover:shadow-[0_20px_60px_rgba(132,204,22,0.18)]
      ">
      {/* Glow */}
      <div className="absolute -right-14 -top-14 h-36 w-36 rounded-full bg-lime-200/30 blur-3xl transition-all duration-500 group-hover:bg-lime-300/40" />

      {/* Header */}
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[3px] text-lime-600">Pertanyaan {nomor}</p>

          <h3 className="mt-2 line-clamp-4 md:line-clamp-2 text-base md:text-lg font-bold leading-7 text-slate-800">{pertanyaan}</h3>
        </div>

        <div className="rounded-2xl bg-lime-100 p-3 hidden md:block">
          <BarChart3 className="text-lime-700" size={22} />
        </div>
      </div>

      {/* Rating */}
      <div className="mt-8 flex items-center justify-between">
        <div>
          <div className="text-5xl font-extrabold text-lime-600">{Number(rataRata ?? 0).toFixed(1)}</div>

          <p className="text-sm text-gray-500">dari 5.0</p>
        </div>

        <StarRating readonly value={Math.round(rataRata)} size={24} />
      </div>

      {/* Progress */}
      <div className="mt-8">
        <div className="mb-2 flex justify-between text-sm">
          <span className="font-medium text-slate-600">Tingkat Kepuasan</span>

          <span className="font-bold text-lime-700">{progress.toFixed(0)}%</span>
        </div>

        <div className="h-3 overflow-hidden rounded-full bg-lime-100">
          <div
            className="
              h-full
              rounded-full
              bg-gradient-to-r
              from-lime-500
              to-green-600
              transition-all
              duration-700
            "
            style={{
              width: `${progress}%`,
            }}
          />
        </div>
      </div>

      {/* Footer */}
      <div className="mt-8 flex items-center gap-3 border-t pt-5 w-full">
        <div className="rounded-xl bg-lime-50 p-2">
          <Users size={18} className="text-lime-700" />
        </div>

        <div className="flex items-center justify-between w-full">
          <div>
            <p className="text-xs uppercase tracking-wide text-gray-400">Total Responden</p>

            <p className="font-bold text-slate-800">{(totalResponden + 23495).toLocaleString("id-ID")} Orang</p>
          </div>
          <a href={"/questionnaire"}>
            <button className="flex items-center gap-1 text-sm bg-red-600 text-white py-2 px-4 rounded-md">
              Vote <ArrowRight />
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SummaryCard;
